// Shared types for prediction caching
// Keep in JS to match the existing codebase.

/**
 * @typedef {Object} CacheKey
 * @property {string} userId
 * @property {string} sport
 * @property {string|number} gameId
 */

/**
 * @typedef {Object} PredictionCacheEntry
 * @property {string} userId
 * @property {string} sport
 * @property {string|number} gameId
 * @property {number} expiresAt - epoch ms
 * @property {Object} prediction - the prediction payload saved by the hook
 */

export const CACHE_NAMESPACE = 'predictions:v1';
